import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyledLabel } from 'elements/Label/Label';
import { SelectSraDeviceSection } from './SraDeviceSection.data';
import { StyleSRADropdown } from './SraDeviceSection.styled';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

const SraDeviceSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly } = props;
    const classes = useStyles();
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                SelectSraDeviceSection(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {
                                    field.isLabel
                                        ? (
                                            <StyledLabel
                                                id={field.key}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                padding={field.padding}
                                                fontSize={field.fontSize}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        )
                                        : (
                                            <StyleSRADropdown>
                                                <FormDropdown
                                                    id={field.key}
                                                    name={field.key}
                                                    label={field.label}
                                                    value={field.value}
                                                    placeholder={field.placeholder}
                                                    handleChange={changeHandler}
                                                    options={field.options}
                                                    isRequired={field.isRequired}
                                                    labelWidth={field.labelWidth}
                                                    width={field.width}
                                                    marginLeft={field.marginLeft}
                                                    marginRight={field.marginRight}
                                                    paddingTop={field.paddingTop}
                                                    readOnly={field.readOnly || isFormReadOnly}
                                                    textAlign={field.textAlign}
                                                    direction={field.direction}
                                                    borderTop={field.borderTop}
                                                    inputTextAlign={field.inputTextAlign}
                                                />
                                            </StyleSRADropdown>
                                        )
                                }
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SraDeviceSection);

SraDeviceSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
};
